const editedToData = (edited) => {
  return Object.entries(edited)
               .map( ([k, v]) => ({'id': k, ...Object.fromEntries( Object.entries(v).map( ([k1, v1]) => [ [k1], v1.value ]  ) ) }) );
};

export default editedToData;